import { useQuery } from "@tanstack/react-query";
import { ListAgreementsQueryFilters, UseListAgreementsQueryOptions } from "./types";
import { getAgreementsService } from "./service";

export const listAgreementsQueryKey = ["agreements"];

export function useListAgreementsQuery(
  filters?: ListAgreementsQueryFilters,
  options?: UseListAgreementsQueryOptions
) {

  const queryFilters = filters ? { ...filters } : undefined;

  if (queryFilters?.search) {
    delete queryFilters.ids;
  }

  const queryKey = listAgreementsQueryKey.concat(JSON.stringify(queryFilters));

  return useQuery({
    queryKey,
    queryFn: async () => getAgreementsService(filters),
    ...options,
  });
}
